(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["swaddle-landing-section"] && !Shopify.designMode) return;
  try {
    
  // Auto-scroll from intro section after 20 seconds if no user action
  let autoScrollTimer;
  let userHasScrolled = false;

  function startAutoScrollTimer() {
    autoScrollTimer = setTimeout(() => {
      if (!userHasScrolled && window.scrollY === 0) {
        const heroSection = document.getElementById('gallery');
        if (heroSection) {
          heroSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, 5000); // 5 seconds
  }

  // Detect user scroll to cancel auto-scroll
  function handleUserScroll() {
    userHasScrolled = true;
    clearTimeout(autoScrollTimer);
    window.removeEventListener('scroll', handleUserScroll);
    window.removeEventListener('wheel', handleUserScroll);
    window.removeEventListener('touchmove', handleUserScroll);
  }

  // Start timer when page loads
  window.addEventListener('load', () => {
    startAutoScrollTimer();
    window.addEventListener('scroll', handleUserScroll);
    window.addEventListener('wheel', handleUserScroll);
    window.addEventListener('touchmove', handleUserScroll);
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('.sobabu-custom-lp a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetQuery = this.getAttribute('href');
      const target = document.querySelector(targetQuery);
      
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
        // Auto-play video when scrolling to video section
        if (targetQuery === '#video') {
          setTimeout(() => {
            const video = document.getElementById('productVideo');
            if (video && video.tagName === 'VIDEO') {
              video.play().catch(err => console.log('Autoplay prevented:', err));
            }
          }, 800);
        }
      }
    });
  });

  // Horizontal scroll indicator for mobile/tablet
  const scrollContainer = document.getElementById('featuresScroll');
  const indicator = document.getElementById('scrollIndicator');
  
  if (scrollContainer && indicator) {
    const dots = indicator.querySelectorAll('.scroll-dot');
    const cards = scrollContainer.querySelectorAll('.feature-card');
    
    scrollContainer.addEventListener('scroll', function() {
      const scrollLeft = scrollContainer.scrollLeft;
      const scrollWidth = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      const scrollPercentage = scrollLeft / scrollWidth;
      const cardIndex = Math.round(scrollPercentage * (cards.length - 1));
      
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === cardIndex);
      });
    });
    
    // Click dots to scroll to specific card
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        const card = cards[index];
        if (card) {
          const scrollLeft = card.offsetLeft - scrollContainer.offsetLeft;
          scrollContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /*
  // Horizontal scroll indicator (FOR NEW GALLERY)
  */
  const galleryScrollContainer = document.getElementById('galleryScrollContainer');
  const galleryIndicator = document.getElementById('galleryScrollIndicator');
  
  if (galleryScrollContainer && galleryIndicator) {
    const galleryDots = galleryIndicator.querySelectorAll('.scroll-dot');
    const galleryCards = galleryScrollContainer.querySelectorAll('.gallery-image-card');
    
    galleryScrollContainer.addEventListener('scroll', function() {
      const scrollLeft = galleryScrollContainer.scrollLeft;
      const scrollWidth = galleryScrollContainer.scrollWidth - galleryScrollContainer.clientWidth;
      
      // Handle division by zero if scrollWidth is 0
      if (scrollWidth === 0) return;
      
      const scrollPercentage = scrollLeft / scrollWidth;
      
      // Calculate which card is most visible
      const cardIndex = Math.round(scrollPercentage * (galleryCards.length - 1));
      
      // Update dots
      galleryDots.forEach((dot, index) => {
        if (index === cardIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    });
    
    // Click dots to scroll to specific card
    galleryDots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        const card = galleryCards[index];
        if (card) {
          const scrollLeft = card.offsetLeft - galleryScrollContainer.offsetLeft;
          galleryScrollContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      });
    });
  }


  } catch(e) { console.error(e); }
})();
})();
